import {
    AccountActionTypes,
    AccountState,
    LOGIN_FAILURE,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    AUTHY_VERIFY,
    LOG_OUT
} from './types';

const initialState: AccountState = {
    user: null,
    loading: false,
    error: null,
    token: null,
    userName: null,
    password: null
};

const accountReducer = (
    state: AccountState = initialState,
    action: AccountActionTypes
): AccountState => {
    switch (action.type) {
        case LOGIN_REQUEST: {
            return { ...state, loading: true };
        }
        case LOGIN_SUCCESS: {
            return {
                ...state,
                loading: false,
                error: null,
                token: action.payload.token,
                user: action.payload.user
            };
        }

        case LOGIN_FAILURE: {
            return {
                ...state,
                loading: false,
                token: null,
                error: action.payload.error,
            };
        }

        case AUTHY_VERIFY: {
            return {
                ...state,
                loading: false,
                password: action.payload.password,
                userName: action.payload.userName
            };
        }

        case LOG_OUT: {
            return {
                ...state,
                user: null,
                token: null,
                error: null,
                userName: null,
                password: null
            };
        }
        default:
            return state;
    }
};
export { accountReducer };